<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-40" @mousedown="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row>
                <b-col style="text-align:end;">
                  <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
                </b-col>
              </b-row>
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ $t('requestToPay.cancel_rtp') }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="10" md="8" lg="10" xl="8">
                  <select class="cancelReasonCode form-group" style="width:100%" v-model="reasonCode">
                    <option value="AC02">{{ $t('requestToPay.dbtr_invld_acc_nbr') }}</option>
                    <option value="AM09">{{ $t('requestToPay.wrng_amnt') }}</option>
                    <option value="BE16">{{ $t('requestToPay.dbtr_invld_acc_id_or_mssg') }}</option>
                    <option value="DRTP">{{ $t('requestToPay.dupplicate') }}</option>
                    <option value="DT01">{{ $t('requestToPay.invld_dt') }}</option>
                    <option value="MODT">{{ $t('requestToPay.mdfd_rtp') }}</option>
                    <option value="PAID">{{ $t('requestToPay.paid') }}</option>
                    <option value="TECH">{{ $t('requestToPay.tchncl_err') }}</option>
                    <option value="OTHER">{{ $t('requestToPay.othr_rsn') }}</option>
                  </select>
                  <textarea class="cancelReasonLabel commentTextArea" maxlength="35" isMandatory
                    v-if="reasonCode === 'OTHER'" v-model="reasonLabel"
                    :placeholder="$t('requestToPay.cancel_rsn')">
                  </textarea>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
              <b-button variant="primary" :disabled="!reasonCode"
                @click="selectReasonCode()">{{ $t('requestToPay.cancel_rtp') }}
              </b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'ChoicePaymentCancel',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      mousedown: false,
      reasonCode: 'AC02',
      reasonLabel: ''
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height: maxHeight' + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    selectReasonCode () {
      this.$emit('close')
      this.$bus.$emit('cancel-payment', {
        endToEndId: this.data.endToEndId,
        reasonType: this.reasonCode === 'OTHER' ? 'Proprietary' : 'Code',
        reason: this.reasonCode === 'OTHER' ? this.reasonLabel : this.reasonCode
      })
    }
  }
}
</script>
<style scoped>
</style>
